'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { useTelegramEnv } from '@/lib/TelegramProvider';
import { useTranslations } from '@/i18n/useTranslations';

import PhoneIcon from '@/assets/icons/phone.svg';
import ProfileIcon from '@/assets/icons/profile.svg';

import styles from './Navbar.module.sass';

export default function Navbar() {
  const { t } = useTranslations('Navbar');
  const { isTWA } = useTelegramEnv();
  const pathname = usePathname();
  const profileHref = isTWA ? '/settings' : '/profile';

  const isActive = (href: string) =>
    href === '/' ? pathname === '/' : pathname === href || pathname?.startsWith(`${href}/`);

  return (
    <div className={styles.wrapper} id="navbarWrapper">
      <nav className={styles.navbar}>
        <Link
          href="/"
          className={isActive('/') ? styles.navButtonAccent : styles.navButton}
          aria-current={isActive('/') ? 'page' : undefined}
        >
          <PhoneIcon className={styles.icon} aria-hidden="true" width={28} height={28} />
          <span>{t('calls')}</span>
        </Link>
        <Link
          href={profileHref}
          className={isActive(profileHref) ? styles.navButtonAccent : styles.navButton}
          aria-current={isActive(profileHref) ? 'page' : undefined}
        >
          <ProfileIcon className={styles.icon} aria-hidden="true" width={28} height={28} />
          <span>{t('profile')}</span>
        </Link>
      </nav>
    </div>
  );
}
